module.exports = __webpack_public_path__ + "img/logo.88d5f9c6.svg";